import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { PackageCheck } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { PageHeader } from "../components/common/PageHeader";
import { DataTable } from "../components/common/DataTable";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";

export default function ReturnWorklist() {
  const [refresh, setRefresh] = useState(0);
  const [acceptingId, setAcceptingId] = useState(null);
  const accept = async (r) => {
    if (acceptingId) return;
    setAcceptingId(r.id);
    try { await api.post("/returns/accept", { material_id: r.id, idempotency_key: uuidv4() }); toast.success("Return accepted → GRN_COMPLETED"); setRefresh((n) => n + 1); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setAcceptingId(null); }
  };
  const columns = [
    { key: "material_number", label: "Serial", mono: true },
    { key: "type_name", label: "Type", render: (r) => <Badge variant="secondary">{r.type_name}</Badge> },
    { key: "project_name", label: "Project" },
    { key: "field_user_name", label: "Field User", hideMobile: true },
    { key: "return_reason", label: "Reason", hideMobile: true },
  ];
  return (
    <div>
      <PageHeader title="Return Worklist" subtitle="Materials returned by field users — any authorized store user may accept" />
      <DataTable testid="returns-table" columns={columns} searchPlaceholder="Search serial..." refreshKey={refresh}
        load={(p) => api.get("/returns/worklist", { params: p }).then((r) => r.data)} emptyText="No pending returns"
        rowActions={(r) => <Button data-testid={`return-accept-btn-${r.id}`} variant="ghost" size="sm" disabled={acceptingId === r.id} onClick={() => accept(r)}><PackageCheck className="mr-1 h-4 w-4 text-emerald-600" /> Accept</Button>} />
    </div>
  );
}
